__turbopack_context__.v({
  "className": "playfair_display_b8729abe-module__FzkLmq__className",
});
